import {
  CREATIVE_REJECTION_REASON_CODE_VALUES,
  CREATIVE_REJECTION_REASON_MESSAGE_TO_CODE,
  CREATIVE_REJECTION_REASON_UNKNOWN,
} from './constants';

const normalizeRejectionReasonMessage = (message: string): string => message.trim();

const resolveRejectionReasonCode = (reason: string): string => {
  const trimmed = normalizeRejectionReasonMessage(reason);

  if (!trimmed) {
    return CREATIVE_REJECTION_REASON_UNKNOWN;
  }

  if (CREATIVE_REJECTION_REASON_CODE_VALUES.has(trimmed)) {
    return trimmed;
  }

  const codePrefixMatch = /^([a-z0-9_]+)=/.exec(trimmed);

  if (codePrefixMatch && CREATIVE_REJECTION_REASON_CODE_VALUES.has(codePrefixMatch[1])) {
    return codePrefixMatch[1];
  }

  return CREATIVE_REJECTION_REASON_MESSAGE_TO_CODE[trimmed] ?? CREATIVE_REJECTION_REASON_UNKNOWN;
};

/** Maps API rejection message strings to stable QCheck reason codes for Amplitude. */
export const mapCreativeRejectionReasonsToCodes = (reasons: string[]): string[] =>
  reasons.map(resolveRejectionReasonCode);

export type CreativeRejectionReasonSource = {
  rejectionReason?: string[] | null;
  asset?: { rejectionReason?: string[] | null } | null;
};

export const extractCreativeRejectionReasons = (creative: CreativeRejectionReasonSource): string[] | undefined => {
  const reasons = creative.rejectionReason ?? creative.asset?.rejectionReason ?? undefined;

  return reasons?.length ? reasons : undefined;
};
